<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>As well as being a working mother of three, Kim Godden has tirelessly strived to bring her work to life with the power of words. Taking inspiration from the world around her has enabled her to challenge topics within her novels and bring new perspectives to her readers.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c03fd53e